import { render } from "./CategoryForm.vue?vue&type=template&id=5b8d77c0&scoped=true"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"

import "./CategoryForm.vue?vue&type=style&index=0&id=5b8d77c0&scoped=true&lang=css"
import "./CategoryForm.vue?vue&type=style&index=1&id=5b8d77c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8d77c0"]])

export default __exports__